import React, { forwardRef, ForwardedRef } from 'react';
import cn from 'classnames';
import styles from './BaseButton.module.scss';

function Button(
  { className, children, ...props }: React.ComponentPropsWithoutRef<'button'>,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <button className={cn(styles.button, className)} {...props} ref={ref}>
      {children}
    </button>
  );
}

export default forwardRef(Button);
